import { createContext, useContext, useEffect, useState } from "react";

import { api } from "@/lib/api";
import { formatCurrency } from "@/lib/currency";
import { useAuth } from "@/context/AuthContext";

const defaultSettings = {
  usd_to_bob: 6.96,
  base_currency: "USD",
  display_mode: "USD",
  is_default: true,
};
const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(defaultSettings);

  const refreshCurrency = async () => {
    const response = await api.get("/settings/currency");
    setSettings(response.data);
    return response.data;
  };

  useEffect(() => {
    if (user) {
      refreshCurrency().catch(() => setSettings(defaultSettings));
    }
  }, [user]);

  const formatAmount = (value) => formatCurrency(value, settings);

  return (
    <CurrencyContext.Provider value={{ settings, setSettings, refreshCurrency, formatAmount }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}
